import { useState } from 'react'
import {
	Navigate,
	Route,
	BrowserRouter as Router,
	Routes,
} from 'react-router-dom'
import Layout from './components/Layout/Layout'
import Connections from './pages/Connections/Connections'
import Dashboard from './pages/Dashboard/Dashboard'
import Login from './pages/Login/Login'
import QueueDetail from './pages/QueueDetail/QueueDetail'
import Queues from './pages/Queues/Queues'
import Users from './pages/Users/Users'
import './styles/globals.css'

function App() {
	const [isAuthenticated, setIsAuthenticated] = useState(false)
	return (
		<Router>
			<Routes>
				<Route
					path='/login'
					element={
						!isAuthenticated ? (
							<Login setIsAuth={setIsAuthenticated} />
						) : (
							<Navigate to='/' />
						)
					}
				/>
				<Route
					path='/'
					element={isAuthenticated ? <Layout /> : <Navigate to='/login' />}
				>
					<Route index element={<Dashboard />} />
					<Route path='connections' element={<Connections />} />
					<Route path='/queues' element={<Queues />} />
					<Route path='/queues/:queueId' element={<QueueDetail />} />
					<Route path='users' element={<Users />} />
				</Route>
			</Routes>
		</Router>
	)
}

export default App
